import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType } from 'vue';
  import { Order } from '@/types';
  import CarLargeIcon from './CarLarge.vue';
  import CarSmallIcon from './CarSmall.vue';
  import HotelLargeIcon from './HotelLarge.vue';
  import HotelSmallIcon from './HotelSmall.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    type: {
      type: String as PropType<Order.Ml.OrderProductType>,
      required: true,
    },
    sequence: {
      type: Number,
      required: true,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props

  const colors = [
    { str: 'var(--image-str-rosa-pink)', bg: 'var(--image-bg-yellow)' },
    { str: 'var(--image-str-violet)', bg: 'var(--image-bg-salad-green)' },
    { str: 'var(--image-str-violet)', bg: 'var(--image-bg-rosa-pink)' },
    { str: 'var(--image-str-yellow)', bg: 'var(--image-bg-brown)' },
    { str: 'var(--image-str-violet)', bg: 'var(--image-bg-sky-blue)' },
    { str: 'var(--image-str-violet)', bg: 'var(--image-bg-turquese)' },
    { str: 'var(--image-str-brown)', bg: 'var(--image-bg-orange)' },
    { str: 'var(--image-str-violet)', bg: 'var(--image-bg-yellow)' },
    { str: 'var(--image-str-salad-green)', bg: 'var(--image-bg-watermelone)' },
    { str: 'var(--image-str-salad-green)', bg: 'var(--image-bg-violet)' },
  ];

  

  const icon = computed(() => {
    switch (props.type) {
      case Order.Ml.OrderProductType.Car:
        return props.isLarge ? CarLargeIcon : CarSmallIcon;

      default:
        return props.isLarge ? HotelLargeIcon : HotelSmallIcon;
    }
  });

  const colorBySequence = computed(() => {
    return colors[props.sequence % 10];
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon)), {
    stroke: _unref(colorBySequence).str,
    fill: _unref(colorBySequence).bg
  }, null, 8, ["stroke", "fill"]))
}
}

})